import React, { useEffect, useState } from "react";
import axios from "axios";
import "./NewTaxisHomePageCards.css";
import { Link } from "react-router-dom";

const NewTaxisHomePageCards = () => {
  const [taxis, setTaxis] = useState([]);

  useEffect(() => {
    axios.get("/api/taxiforsale")
      .then((res) => {
        const lastFour = res.data.slice(-4).reverse();
        setTaxis(lastFour);
      })
      .catch((err) => console.error("שגיאה בטעינת המוניות:", err));
  }, []);

  return (
    <div className="NewTaxisHomePageCards__container">
      <h2 className="NewTaxisHomePageCards__title"> המוניות החדשות באתר</h2>
      <div className="NewTaxisHomePageCards__grid">
        {taxis.map((taxi) => (
          <Link
            to={`/taxi/${taxi.id}`}
            key={taxi.id}
            className="NewTaxisHomePageCards__card-link"
          >
            <div className="NewTaxisHomePageCards__card">
              <img
                src={taxi.תמונות?.[0] || "/default-image.jpg"}
                alt={`${taxi.יצרן} ${taxi.דגם}`}
                className="NewTaxisHomePageCards__image"
              />
              <div className="NewTaxisHomePageCards__info">
                <h3 className="NewTaxisHomePageCards__model">{taxi.יצרן} {taxi.דגם}</h3>
                <p className="NewTaxisHomePageCards__year">{taxi.שנתון}</p>
                {Number(taxi.מחיר) <= 4 ? (
  <p className="NewTaxisHomePageCards__price">פורסם ללא מחיר</p>
) : (
  <>
    <p className="NewTaxisHomePageCards__price">₪{taxi.מחיר}</p>
  </>
)}

                <p className="NewTaxisHomePageCards__km">ק"מ: {taxi.קמ}</p>
                <p className="NewTaxisHomePageCards__location">{taxi.אזור_מגורים}</p>
                <h4 className="NewTaxisHomePageCardsh4">המחיר אינו כולל מע"מ</h4>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default NewTaxisHomePageCards;
